import { HelmetProvider } from "react-helmet-async";
import AppRoutes from "./Routes";

function App() {
  return (
    <HelmetProvider>
      <AppRoutes />
    </HelmetProvider>
  );
}

export default App;
